import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown } from "lucide-react";
import { formatPct } from "@/lib/format";

export const MetricCard = ({ icon: Icon, label, value, delta, accent = "brand", index = 0 }) => {
  const accents = {
    brand: "from-brand-500/15 to-transparent text-brand-700 dark:text-brand-400",
    emerald: "from-emerald-500/15 to-transparent text-emerald-600 dark:text-emerald-400",
    amber: "from-amber-500/15 to-transparent text-amber-600 dark:text-amber-400",
    rose: "from-rose-500/15 to-transparent text-rose-600 dark:text-rose-400",
  };
  const positive = delta >= 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.06 }}
      className="relative overflow-hidden rounded-2xl border border-border bg-card p-5 sm:p-6 shadow-sm hover:border-brand-500/30 transition-colors"
      data-testid={`metric-${label}`}
    >
      <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gradient-to-br ${accents[accent]} blur-xl opacity-60`} />
      <div className="relative">
        <div className="flex items-center gap-2 text-muted-foreground">
          {Icon && <Icon className="h-4 w-4" />}
          <span className="text-xs font-mono uppercase tracking-widest">{label}</span>
        </div>
        <div className="mt-3 font-display text-3xl font-bold tracking-tight">{value}</div>
        {delta !== undefined && delta !== null && (
          <div className={`mt-2 inline-flex items-center gap-1 text-sm font-semibold ${positive ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}>
            {positive ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}
            {formatPct(delta)}
          </div>
        )}
      </div>
    </motion.div>
  );
};
